import useBulkCollectionTypeticketData from "../hooks/useBulkCollectionTypeticketData"

interface Props {
  typeticketIds: number[]
}

const TypeticketcollectionDataFetcher: React.FC<Props> = (props: Props) => {
  const { typeticketIds } = props

  useBulkCollectionTypeticketData({ typeticketIds })

  return null
}

export default TypeticketcollectionDataFetcher
